<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container">
      <div class="container-fluid">
        <div class="row">
        	<div class="col-md-2">
            <smallBar></smallBar>
          </div>
          <div class="col-md-10">
            <div class="material-table1-widget dashboard_top_bar">
				      <button class="btn btn-default btn-new" @click="newFixMoneyModal=true;temp_fix_money.money_type = 'income'"><i class="fa fa-plus"></i>&nbsp;建立固定收入</button>
				      <button class="btn btn-default btn-new" @click="newFixMoneyModal=true;temp_fix_money.money_type = 'expend'"><i class="fa fa-minus"></i>&nbsp;建立固定支出</button>
				    </div> 
				    <div class="widget-wrap">
				    	<div class="block-header  clearfix">
				        <div role="group" aria-label="..." class="btn-group pull-left" style="margin-right:10px;">
				          <button @click="now_at='income_active'" class="btn btn-default relative" v-bind:class="{'active': now_at=='income_active' }">
				          	固定收入({{filteFixMoneyByType('income','active').length}})
				          </button>
				          <button @click="now_at='income_history'" class="btn btn-default" v-bind:class="{'active': now_at=='income_history' }">
				          	歷史({{filteFixMoneyByType('income','history').length}})
				          </button>
				        </div>
				        <div role="group" aria-label="..." class="btn-group pull-left" style="margin-right:10px;">
				          <button @click="now_at='expend_active'" class="btn btn-default relative" v-bind:class="{'active': now_at=='expend_active' }">
				          	固定支出({{filteFixMoneyByType('expend','active').length}})
				          </button>
				          <button @click="now_at='expend_history'" class="btn btn-default" v-bind:class="{'active': now_at=='expend_history' }">
				          	歷史({{filteFixMoneyByType('paid','history').length}})
				          </button>
				        </div>
				        <!-- <div class="pull-right form-inline ">
				          <select class="form-control" style="margin-right:10px;"><option value="2019">2019</option></select>
				          <select class="form-control"><option value="2019">1月</option></select>
				        </div> -->
				      </div>

				      <p class="mt-3">固定收支建立之後，將會自動產生該應收應付項目，你可以在收支管理查看，或點擊右側的 <button class="btn btn-success btn-xs"><i class="fa fa-list"></i></button> 查看屬於該項目的明細</p>

				    	<table class="table table-bordered">
				    		<tr>
				    			<th class="col-md-2">項目名稱</th>
				    			<th class="col-md-2">分類</th>
				    			<th class="col-md-2">週期</th>
				    			<th class="col-md-2">起訖時間</th>
				    			<th class="col-md-2">金額</th>
				    			<th class="col-md-2"></th>
				    		</tr>
				    		<tr class="text-left" v-for="fix_money in filtedFixMoney()">
				    			<td>{{fix_money.name}}</td>
				    			<td>{{fix_money.money_category_name}}</td>
				    			<td>{{getPeriodType(fix_money)}}</td>
				    			<td><span v-html="getPeriod(fix_money)"></span></td>
				    			<td>${{fix_money.amount.toLocaleString()}}元</td>
				    			<td>
				    				<button class="btn btn-xs btn-success" @click="showMoneys(fix_money)"><i class="fa fa-list"></i></button>
				    				<button class="btn btn-xs btn-warning" @click="temp_fix_money = fix_money; newFixMoneyModal=true"><i class="fas fa-pencil-alt"></i></button>
				    				<button class="btn btn-xs btn-danger" @click="temp_fix_money = fix_money;deleteFixMoneyModal=true"><i class="fa fa-trash"></i></button>
				    			</td>
				    		</tr>
				    	</table>
				    </div>
          </div>
        </div>
      </div>
    </section>
    <div v-if="newFixMoneyModal">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="newFixMoneyModal=false;resetTempFixMoney()">
          <div class="modal-container modal-center col-md-6" @click.stop>
            <div class="modal-header" style="display:block">
              <a href="#" class="btn-close" @click="newFixMoneyModal=false;resetTempFixMoney()">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms" style="overflow:initial">
              <div>
                <div class="form">
                  <h4 v-if="temp_fix_money.id == '' && temp_fix_money.money_type == 'income'">
                  	建立固定收入之後，會自動產生應收項目
                  </h4>
                  <h4 v-if="temp_fix_money.id == '' && temp_fix_money.money_type == 'expend'">
                  	建立固定支出之後，會自動產生應付項目
                  </h4>
                  <h4 v-if="temp_fix_money.id != ''">
                  	編輯 {{temp_fix_money.name}}
                  </h4>
                  <div class="row" v-if="temp_fix_money.id == ''">
                  	<div class="col-md-6">
                  		<div class="form-group">
		                    <label>項目名稱*：</label>
		                    <input class="form-control" type="text" placeholder="項目名稱" name="title" v-model="temp_fix_money.name" v-validate="'required'">
                      	<span v-show="errors.has('title')" class="help is-danger">請輸入名稱</span>
		                  </div>
                  	</div>
                  	<div class="col-md-6">
                  		<div class="form-group">
		                    <label>項目分類*：</label>
		                    <select style="padding-left:13px !important;" name="money_category_id" v-model="temp_fix_money.money_category_id" class="form-control" v-validate="'required'">
		                    	<option value="">請選擇</option>
		                      <option v-for="category in categories" v-if="category.money_type == temp_fix_money.money_type" :selected="temp_fix_money.money_category_id==category.id" :value='category.id'>{{category.name}}</option>
		                    </select>
                      	<span v-show="errors.has('money_category_id')" class="help is-danger">請選擇</span>
		                  </div>
                  	</div>
                  	<div class="col-md-6">
                  		<div class="form-group">
		                    <label>金額*：</label>
		                    <input class="form-control" type="number" placeholder="金額" name="amount" v-model="temp_fix_money.amount" v-validate="'required|numeric'">
                      <span v-show="errors.has('amount')" class="help is-danger">請輸入金額</span>
		                  </div>
                  	</div>   	
                  	<div class="col-md-6">
                  		<div class="form-group">
		                    <label>週期*：</label>
		                    <div class="row">
		                    	<div class="col-md-4">
		                    		<select style="padding-left:13px !important;" name="money_category_id" v-model="temp_fix_money.period_type" class="form-control" v-validate="'required'">
				                    	<option value="year">每年</option>
				                    	<option value="month">每月</option>
				                    </select>
		                    	</div>
		                    	<div class="col-md-4" v-if="temp_fix_money.period_type == 'year'">
		                    		<select style="padding-left:13px !important;" name="period_month" v-model="temp_fix_money.period_month" class="form-control" v-validate="'required'">
		                    			<option value="">請選擇月份</option>
				                    	<option v-for="month in months" :value="month">{{month}}月</option>
				                    </select>
				                    <span v-show="errors.has('period_month')" class="help is-danger">請選擇</span>
		                    	</div>
		                    	<div class="col-md-4" v-if="temp_fix_money.period_type == 'year' || temp_fix_money.period_type == 'month'">
		                    		<select style="padding-left:13px !important;" name="period_day" v-model="temp_fix_money.period_day" class="form-control" v-validate="'required'">
		                    			<option value="">請選擇日</option>
				                    	<option v-for="day in days" :value="day">{{day}}日</option>
				                    </select>
				                    <span v-show="errors.has('period_day')" class="help is-danger">請選擇</span>
		                    	</div>
		                    </div>
                      	
		                  </div>
                  	</div>  
                  	<div class="col-md-6">
                  		<div class="form-group">
		                    <label>發票*：</label>
		                    <select style="padding-left:13px !important;" name="invoice_status" v-model="temp_fix_money.invoice_status" class="form-control" v-validate="'required'">
		                    	<option value="not_create">要發票</option>
		                    	<option value="no_invoice">不要發票</option>
		                    </select>
		                  </div>
                  	</div>   	
                  </div>
                  <div v-else>

                  </div>
                  <hr>
                  <p class="pointer text-primary" v-if="temp_fix_money.has_date_range==false" @click="temp_fix_money.has_date_range=true">點擊可設定起始與結束日期</p>
                  <div v-else class="row">
                  	<div class="col-md-6">
                  		<div class="form-group">
			                  <label>起始日期</label>
			                  <datepicker :clear-button="true" clear-button-icon="fa fa-times" input-class="form-control" v-model="temp_fix_money.start_at" :format="customFormatter" language="zh"></datepicker>
			                </div>
                  	</div>
                  	<div class="col-md-6">
                  		<div class="form-group">
		                    <label>結束日期</label>
		                    <datepicker :clear-button="true" clear-button-icon="fa fa-times" input-class="form-control" v-model="temp_fix_money.end_at" :format="customFormatter" language="zh"></datepicker>
		                  </div>
                  	</div>
                  	<div class="col-md-12">
                  		<p class="text-gray">如果有填寫起始與初始日期，則會直接建立這週期內的應收款項，如果沒有填寫結束日期，則會依照年度到了才建立整年應收款項</p>
                  	</div>
                  </div>
                </div>
                <div class="text-center">
                  <button class="btn btn-success" @click="submitTempFixMoney()" v-if="temp_fix_money.loading==false">送出</button>
                  <button type="button" class="btn btn-success disabled" disabled="disabled" v-else>
                    <i class="fa fa-spinner fa-spin "></i> 送出中
                  </button>
                  <button class="btn btn-default" @click="newFixMoneyModal = false;resetTempFixMoney()">取消</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showFinanceMoneyModal">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="showFinanceMoneyModal=false;resetTempFixMoney()">
          <div class="modal-container modal-center col-md-6" @click.stop>
            <div class="modal-header" style="display:block">
              <a href="#" class="btn-close" @click="showFinanceMoneyModal=false;resetTempFixMoney()">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms">
              <div>
                <div class="form">
                  <h4>
                  	{{temp_fix_money.name}}
                  </h4>
                  <table class="table table-bordered table-striped">
                  	<tr>
                  		<th>應收日期</th>
                  		<th>實收日期</th>
                  		<th>名稱</th>
                  		<th>分類</th>
			                <th>金額</th>
                  	</tr>
                  	<tr v-for="m in temp_fix_money.finance_moneys">
                  		<td v-html='m.date'></td>
			              	<td v-html='m.finish_at'></td>
			                <td><b>{{m.title}}</b></td>
			                <td>{{m.money_category_name}}</td>
			                <td><b>NT$ {{m.amount.toLocaleString()}}</b></td>
			              </tr>
                  </table>
                </div>
                <div class="text-center">
                  <button class="btn btn-default" @click="showFinanceMoneyModal = false;resetTempFixMoney()">關閉</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="deleteFixMoneyModal">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="deleteFixMoneyModal=false;resetTempFixMoney()">
          <div class="modal-container modal-center col-md-6" @click.stop>
            <div class="modal-header" style="display:block">
            	<h4>
                  	刪除 {{temp_fix_money.name}}
                  </h4>
              <a href="#" class="btn-close" @click="deleteFixMoneyModal=false;resetTempFixMoney()">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms">
              <div>
                <div class="form">
                  
                  <div class="row">
                  	<div class="col-md-6 text-center">
                  		<button v-if="temp_fix_money.loading == false" class="btn btn-default mb-3" @click="deleteFixMoney('only_fix_money')">僅刪除固定支出</button>
                  		<button class="btn btn-default mb-3" v-else>刪除中...</button>
                  		<p>將會刪除此固定收支，但保留已建立的收支項目</p>
                  		<p>你也可以使用『編輯->變更到期日』的方式，到期的項目將會進入歷史</p>
                  		<p>刪除的固定收支不會進入歷史</p>
                  	</div>
                  	<div class="col-md-6 text-center">
                  		<button v-if="temp_fix_money.loading == false" class="btn btn-danger mb-3" @click="deleteFixMoney('all')">刪除固定支出與收支項目{{temp_fix_money.finance_moneys.length}}筆</button>
                  		<button class="btn btn-danger mb-3" v-else>刪除中...</button>
                  		<p class="text-danger">將會永久刪除此固定收支，以及底下的收支項目</p>
                  	</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'
import smallBar from './SmallBar.vue';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'finance_box',
  data() {
    return {
    	newFixMoneyModal: false,
    	showFinanceMoneyModal: false,
    	deleteFixMoneyModal: false,
      temp_fix_money: {},
      fix_moneys:[],
      categories:[],
      now_at: 'income_active',
      months: [],
      days: [],
    }
  },
  created() {
  	this.createMonthDaysData()
    this.getMoneys()
    this.resetTempFixMoney()
  },
  components: {
    smallBar,Datepicker
  },
  props: ['toggle_aside'],
  methods: {
  	createMonthDaysData(){
  		let vm = this
			for (var i = 1; i <= 12; i++) {
			    vm.months.push(i);
			}
			for (var i = 1; i <= 31; i++) {
			    vm.days.push(i);
			}
  	},
    getMoneys(){
      let vm = this
      this.axios.get('finances/fix_moneys')
      .then(function(response) {
        if (response.status == 200) {
          vm.fix_moneys = response['data']['data']['fix_moneys']
          vm.categories = response['data']['data']['money_categories']
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    resetTempFixMoney(){
      let vm = this
      vm.temp_fix_money = {
        id: '',
        name: '',
        period_type: 'year',
        period_month: '',
        money_type: 'income',
        period_day: '',
        amount: '',
        start_at: null,
        end_at: null,
        money_category_name: '',
        money_category_id: '',
        finance_moneys: [],
        has_date_range: false,
        loading: false,
        invoice_status: 'not_create',
      }
    },
    customFormatter(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    submitTempFixMoney(){
      let vm = this
      vm.temp_fix_money.loading = true
      vm.temp_fix_money.amount = parseInt(vm.temp_fix_money.amount)

      this.$validator.validateAll().then((result) => {
        if (result) {


          if(vm.temp_fix_money.id == ''){
		        //建立新的fix_money
		        const vm = this;
		        this.axios.post('finances/fix_moneys', {
		          fix_money: vm.temp_fix_money,
		        })
		        .then(function(response) {
		          if (response.status == 200) {
		            vm.fix_moneys.push(response['data']['data']['fix_money'])
		            vm.now_at = vm.temp_fix_money.money_type+'_active'
		            vm.resetTempFixMoney()
		            vm.newFixMoneyModal = false

		          } else {
		          	vm.temp_fix_money.loading = false
		          	vm.$toastr.w('無法建立，請稍後再試，已通知工程師進行問題排除!')
		            console.log(response)
		          }
		        })
		        .catch(function(error) {
		        	vm.temp_fix_money.loading = false
	          	vm.$toastr.w('無法建立，請稍後再試，已通知工程師進行問題排除')
		          console.log('error:', error)
		        });

		      }else{
		        //編輯fix money
		        const vm = this;
		        this.axios.put('finances/fix_moneys/'+vm.temp_fix_money.id, {
		          fix_money: vm.temp_fix_money,
		        })
		        .then(function(response) {
		          if (response.status == 200) {
		            var index = vm.fix_moneys.indexOf(vm.temp_fix_money)
		            vm.fix_moneys.splice(parseInt(index), 1)
		            vm.fix_moneys.push(response['data']['data']['fix_money'])
		            vm.resetTempFixMoney()
		            vm.newFixMoneyModal = false

		          } else {
		          	vm.temp_fix_money.loading = false
		          	vm.$toastr.w('無法建立，請稍後再試，已通知工程師進行問題排除')
		            console.log(response)
		          }
		        })
		        .catch(function(error) {
		        	vm.temp_fix_money.loading = false
	          	vm.$toastr.w('無法建立，請稍後再試，已通知工程師進行問題排除')
		          console.log('error:', error)
		        })
		      }
        }else{
        	vm.temp_fix_money.loading = false
        }
      });
    },
    getPeriod(fix_money){
    	var result = '每年自動產生'
    	var start_at = "無"
    	var end_at = "無"
    	if(fix_money.start_at || fix_money.end_at ){
    		if(fix_money.start_at){
    			start_at = fix_money.start_at
    		}
    		if(fix_money.end_at){
    			end_at = fix_money.end_at
    		}

    		result = '<span>' + start_at + '</span>~<span>' + end_at + '</span>'
    	}
    	return result
    },
    getPeriodType(fix_money){
    	var result = ''
    	switch(fix_money.period_type){
	    	case 'year':
	    		result = '每年' + fix_money.period_month + '月' + fix_money.period_day + '日';
	    	 	break;
	  	  case 'month':
	  	    result = '每月' + fix_money.period_day + '日'
	  	    break;
  	  }
  	  return result
    },
    showMoneys(fix_money){
    	let vm = this
    	vm.showFinanceMoneyModal = true
    	vm.temp_fix_money = fix_money
    },
    filteFixMoneyByType(type,active){
    	let result = this.fix_moneys.filter(m => m.money_type == type)
    	if(active == 'active'){
    		result = result.filter(m => {
				    return m.end_at == null || Date.now() <= new Date(m.end_at)
				});
    	}else{
    		result = result.filter(m => {
				    return m.end_at != null && Date.now() > new Date(m.end_at)
				});
    	}
      return result
    },
    filtedFixMoney(){
    	let vm = this
    	let result = this.fix_moneys

    	if(vm.now_at == 'income_active' || vm.now_at == "income_history"){
    		result = result.filter(m => m.money_type == 'income')
    	}else{
    		result = result.filter(m => m.money_type == 'expend')
    	}

    	if(vm.now_at == 'income_active' || vm.now_at == "expend_active"){
    		result = result.filter(m => {
				    return m.end_at == null || Date.now() <= new Date(m.end_at)
				});
    	}else{
    		result = result.filter(m => {
				    return m.end_at != null && Date.now() > new Date(m.end_at)
				});
    	}
      return _.orderBy(result, 'created_at','desc')
    },
    deleteFixMoney(type){
    	// delete in html
    	let vm = this;
    	vm.temp_fix_money.loading = true
      this.axios.delete('finances/fix_moneys/'+vm.temp_fix_money.id, {
        params: {
          type: type,
        }
      })
      .then(function(response) {
        if (response.status == 200) {
        	var index = vm.fix_moneys.indexOf(vm.temp_fix_money)
		      vm.fix_moneys.splice(parseInt(index), 1)
		      vm.deleteFixMoneyModal = false
		      vm.resetTempFixMoney()
        } else {
        	vm.temp_fix_money.loading = false
          vm.$toastr.w('無法刪除，請稍後再試，已通知工程師進行問題排除')
        }
      })
      .catch(function(error) {
      	vm.temp_fix_money.loading = false
        vm.$toastr.w('無法刪除，請稍後再試，已通知工程師進行問題排除')
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// FixedMoney.vue?8b51bb32